import { Diamond } from "lucide-react";

const Marquee = ({ items, dark = false }) => {
  const row = (
    <div className="flex items-center shrink-0">
      {items.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`font-mono text-xs sm:text-sm tracking-[0.2em] uppercase px-8 ${
              dark ? "text-white/70" : "text-royal"
            }`}
          >
            {item}
          </span>
          <Diamond size={9} className={dark ? "text-volt" : "text-royal/40"} fill="currentColor" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee"
      className={`overflow-hidden py-5 border-y ${
        dark ? "bg-navy-deep border-white/10" : "bg-white border-blue-900/10"
      }`}
    >
      <div className="flex w-max animate-marquee-slow">
        {row}
        {row}
      </div>
    </div>
  );
};

export default Marquee;
